const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const mcIsLogged=()=>window.moonscCustomerLoggedIn===true;
const mcKey=()=>mcIsLogged()&&window.moonscCustomerId?'moonsc-wishlist-'+window.moonscCustomerId:null;
const mcRead=raw=>[...new Set((raw||'').split(',').map(x=>x.trim()).filter(Boolean))];
function mcMigrate(){let key=mcKey();if(!key)return;try{let owner=localStorage.getItem('moonsc-wishlist-legacy-owner'),old=mcRead(localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY));if(old.length&&(!owner||owner===String(window.moonscCustomerId))){localStorage.setItem(key,[...new Set([...mcRead(localStorage.getItem(key)),...old])].join(','));localStorage.setItem('moonsc-wishlist-legacy-owner',String(window.moonscCustomerId));localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY)}}catch(e){console.warn(e)}}

const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectorswish = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.grid__item',
};

document.addEventListener('DOMContentLoaded', () => {
  mcMigrate();
  var text=document.getElementsByClassName("product-recommendations");
	var len=text.length;	
	if(!len)initButtons();
        initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  //console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  //console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  //console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=wish`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectorswish.productCard);
    return productCard?productCard.outerHTML:'';
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  if(!wishlist.length){grid.innerHTML='';grid.classList.add(GRID_LOADED_CLASS);document.dispatchEvent(new CustomEvent('shopify-wishlist:init-product-grid',{detail:{wishlist:[]}}));return;}
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.filter(Boolean).join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    button.classList.toggle('iniactive');
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    button.classList.toggle(BUTTON_ACTIVE_CLASS,wishlistContains(productHandle));
    button.setAttribute('aria-pressed',String(wishlistContains(productHandle)));
    if (button.dataset.moonscWishlistBound === '1') return;
    button.dataset.moonscWishlistBound = '1';
    button.addEventListener('click', (event) => {
      if (!mcIsLogged()) {
        event.preventDefault();event.stopPropagation();
        window.location.assign(window.moonscAccountLoginUrl || '/account/login');
        return;
      }
      updateWishlist(productHandle);
      initButtons();
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectorswish.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectorswish.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const key=mcKey();if(!key)return [];
  try{return mcRead(localStorage.getItem(key))}catch(e){return []}
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  const key=mcKey();if(!key)return '';
  try{if(array.length)localStorage.setItem(key,wishlist);else localStorage.removeItem(key)}catch(e){console.warn(e)}

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);
  updateWishlistCount();
  initButtons();
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const updateWishlistCount = () => {
    const wishlist = getWishlist();       
    document.querySelectorAll('[data-js-wishlist-count]').forEach(el=>{el.textContent=wishlist.length;el.setAttribute('data-js-wishlist-count',wishlist.length)});
     
    if (wishlist.length==0){
         $(".wishlist-text").css("display", "block");
    }
   else{
      $(".wishlist-text").css("display", "none");
   }     
};

document.addEventListener('DOMContentLoaded',updateWishlistCount);
window.moonscWishlistGet=getWishlist;